import { cn } from "src/lib/utils";

export const HeadlineSize8Medium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h1
      className={cn(
        "text-brand-blue-1 text-[24px] leading-[32px] font-semibold",
        className,
      )}
    >
      {children}
    </h1>
  );
};

export const HeadlineSize9Medium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h2
      className={cn(
        "text-brand-blue-1 text-[20px] leading-[32px] font-medium",
        className,
      )}
    >
      {children}
    </h2>
  );
};

export const HeadlineSize10Medium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h2
      className={cn(
        "text-secondary-2 text-[16px] leading-[21px] font-bold",
        className,
      )}
    >
      {children}
    </h2>
  );
};
export const HeadlineSize10 = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h2
      className={cn(
        "text-brand-blue-1 text-[16px] leading-[24px] font-medium",
        className,
      )}
    >
      {children}
    </h2>
  );
};

export const CaptionSMedium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p
      className={cn(
        "text-secondary-2 text-[12px] leading-[14px] font-medium",
        className,
      )}
    >
      {children}
    </p>
  );
};

export const CaptionS = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p className={cn("text-secondary-2 text-[12px] leading-[14px]", className)}>
      {children}
    </p>
  );
};
export const CaptionMLow = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <label
      className={cn("text-brand-blue-2 text-[14px] leading-[18px]", className)}
    >
      {children}
    </label>
  );
};
export const CaptionMLowMedium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <label
      className={cn(
        "text-brand-blue-2 text-[14px] leading-[18px] font-medium",
        className,
      )}
    >
      {children}
    </label>
  );
};

export const AcceleratorTable = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p className={cn("text-secondary-2 text-[14px] leading-[18px]", className)}>
      {children}
    </p>
  );
};

export const BodySReg = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p className={cn("text-secondary-2 text-[14px] leading-[20px]", className)}>
      {children}
    </p>
  );
};
export const BodySMedium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p
      className={cn(
        "text-brand-blue-1 text-[14px] leading-[20px] font-medium",
        className,
      )}
    >
      {children}
    </p>
  );
};

export const BodyLBold = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p
      className={cn(
        "text-secondary-2 text-[18px] leading-[28px] font-bold",
        className,
      )}
    >
      {children}
    </p>
  );
};

export const BodyMReg = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p
      className={cn(
        "text-secondary-2 text-[16px] leading-[24px] font-bold",
        className,
      )}
    >
      {children}
    </p>
  );
};

export const BodyMMedium = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <p
      className={cn(
        "text-secondary-2 text-[16px] leading-[24px] font-medium",
        className,
      )}
    >
      {children}
    </p>
  );
};
